import React from 'react'
import styled from "styled-components";
import {Col, Layout, Row, Typography, Button} from "antd";
import {
    InstagramOutlined,
    ClockCircleOutlined,
    UserOutlined,
    YoutubeFilled,
    TwitterOutlined,
    WhatsAppOutlined
} from '@ant-design/icons'
import NavItems from "./NavItems";
import Logo from '../assets/imgs/logo.png';

import {NavLink, Link} from "react-router-dom";
import {GRAY_2, GREE_1} from "../utils/colors";
import {useSiteSettings} from "../contexts/SiteSettingsContext";
import {ROUTES} from "../constants/PathRoutes";

const {Header} = Layout;
const {Text} = Typography;

const padding_header = '32px';

const TopBar = styled.div`
  background: black;
  padding: 8px ${padding_header};
  color: white;
  font-size: 13px;
`

const TopBarContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
`

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`

const SocialLinks = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

const SocialIcon = styled.a`
  color: white;
  font-size: 18px;
  transition: all 0.3s ease;

  &:hover {
    color: #FFD700;
    transform: scale(1.2);
  }
`

const WorkingHours = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: white;
`

const AssociateLink = styled(Link)`
  color: white;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    color: #FFD700;
  }
`

const BecomeAssociateButton = styled(Button)`
    background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
    border: none;
    color: #000;
    font-weight: bold;
    height: 32px;
    //padding: 0 20px;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
    transition: all 0.3s ease;

    &:hover {
        background: linear-gradient(135deg, #FFA500 0%, #FFD700 100%);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 215, 0, 0.5);
        color: #000;
    }

    &:active {
        transform: translateY(0);
    }
`

const StyledHeader = styled(Header)`


  background: ${GRAY_2};

  padding: 0 0 0 ${padding_header};
  z-index: 99;
  box-shadow: 0px 5px 20px rgb(74 74 74 / 10%);
`
const ImageLogo = styled.img`
  //background: red;
  max-width: 100%;
  width: 200px;
  //margin-top: 15px;
  //height: 50px;
  //max-height: 100%;
  //width: 100%;
  //object-fit: cover;
  //height: 37px;
  //max-width: min-content;
`


const Container = styled.div`
  //background: ${GREE_1};
  padding-right: ${padding_header};
  width: 100%;
  
`


const LogoContainer = styled.div`
    border-radius: 0px 16px 16px 0px;
    height: 64px;
    width: 100%;
    background: ${GRAY_2};
    display: flex;
    //justify-content: center;
    align-items: center;
    transform: translateX(12px);
    position: relative;
    z-index: 2;
`

export default function PublicActionBar() {
    const {settings} = useSiteSettings();

    return (<>
            <TopBar>
                <TopBarContent>
                    <LeftSection>
                        <SocialLinks>
                            {settings.instagram_url && (
                                <SocialIcon href={settings.instagram_url}
                                            target="_blank"
                                            rel="noopener noreferrer">
                                    <InstagramOutlined/>
                                </SocialIcon>
                            )}
                            {settings.youtube_url && (
                                <SocialIcon href={settings.youtube_url}
                                            target="_blank"
                                            rel="noopener noreferrer">
                                    <YoutubeFilled/>
                                </SocialIcon>
                            )}
                            {settings.twitter_url && (
                                <SocialIcon href={settings.twitter_url}
                                            target="_blank"
                                            rel="noopener noreferrer">
                                    <TwitterOutlined/>
                                </SocialIcon>
                            )}
                            {settings.whatsapp && (
                                <SocialIcon
                                    href={`https://wa.me/${settings.whatsapp.replace(/\D/g, '')}`}
                                    target="_blank" rel="noopener noreferrer">
                                    <WhatsAppOutlined/>
                                </SocialIcon>
                            )}
                        </SocialLinks>
                        {settings.working_hours && (
                            <WorkingHours>
                                <ClockCircleOutlined/>
                                <Text
                                    style={{color: 'white', fontSize: '13px'}}>
                                    {settings.working_hours}
                                </Text>
                            </WorkingHours>
                        )}
                    </LeftSection>

                    <RightSection>
                        <AssociateLink to={ROUTES.AREA_ASSOCIADO_LOGIN}>
                            <UserOutlined/>
                            Área do Associado
                        </AssociateLink>
                        <Link to={ROUTES.AREA_ASSOCIADO_CADASTRO}>
                            <BecomeAssociateButton>
                                Seja um Associado
                            </BecomeAssociateButton>
                        </Link>
                    </RightSection>
                </TopBarContent>
            </TopBar>

            <StyledHeader>
                <Row>

                    <Col xs={16} sm={12} md={7} lg={6} xl={6}>
                        <NavLink to={'/'}>
                            <LogoContainer>

                                <ImageLogo src={Logo}/>

                            </LogoContainer>
                        </NavLink>
                    </Col>
                    <Col flex={'auto'}>
                        <Container>


                            <Row justify={'end'}>
                                <Col>
                                    <NavItems/>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>

            </StyledHeader>
        </>
    )
}